<template>
  <v-container>
    <btn-a class="ma-2" outlined rounded color="primary" @click="jobStatusDialogOpen">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-list two-line subheader v-if="value.jobStatus">
      <div v-for="(item,i) in value.jobStatus" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title v-text="item.status"></v-list-item-title>
            <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="jobStatusDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="jobStatusRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="value.jobStatus && value.jobStatus.length > 0"></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="jobStatusDialog"
      title="Job Status"
      @confirm="jobStatusConfirm"
      @cancel="jobStageStatusDialogCancel"
    >
      <jobStatusForm ref="form" v-model="jobStatusSelected" :status="jobStatusComp" />
    </dialog-d>
  </v-container>
</template>


<script>
import jobStatusForm from "../environments/jobStatusForm";
export default {
  components: { jobStatusForm },
  props: {
    value: {
      default: () => {
        return {
          description: "",
          jobStatus: [],
          jobStageStatus: [],
          calendarProds: [],
          calendarExcs: []
        };
      }
    }
  },
  data() {
    return {
      jobStatusSelected: {},
      jobStatusSelectedRef: null
    };
  },
  computed: {
    jobStatusComp() {
      let jobStatus = [];
      if (!this.value.jobStatus) return jobStatus;
      this.value.jobStatus.forEach(js => {
        if (js.status != this.jobStatusSelected.status)
          jobStatus.push(js.status);
      });
      return jobStatus;
    }
  },
  methods: {
    jobStageStatusDialogCancel() {
      this.jobStatusSelectedRef = null;
    },
    jobStatusConfirm() {
      if(!this.$refs.form.isValid()) return;
      if (this.jobStatusSelectedRef) {
        Object.assign(this.jobStatusSelectedRef, this.jobStatusSelected);
      } else {
        this.value.jobStatus.push(this.jobStatusSelected);
      }
      this.$refs.jobStatusDialog.open();
      this.jobStatusSelectedRef = null;
    },
    jobStatusRemove(jobStatus) {
      let index = this.value.jobStatus.indexOf(jobStatus);
      if (index >= 0) this.value.jobStatus.splice(index, 1);
    },
    jobStatusDialogOpen(jobStatus) {
      if (jobStatus) {
        this.jobStatusSelectedRef = jobStatus;
        let obj = {};
        Object.assign(obj, jobStatus);
        this.jobStatusSelected = obj;
      } else {
        this.jobStatusSelected = {};
      }

      this.$refs.jobStatusDialog.open();
    }
  }
};
</script>